export const DISPATCH_SUMMARY_EXPORTS_LIST_PATH = "/dispatch-summary-exports";
export const CREATE_DISPATCH_SUMMARY_EXPORT_PATH =
  "/dispatch-summary-exports/create";
